import { fileUpload, getRequest, postRequest } from './request'
export function getDistribution(){
    return getRequest('/user/groupByCountry')
}